<template>
  <div class="animated fadeIn">
      <b-row>
         <b-col sm="12" md="12">
            <b-card class="card-accent-info" header="INFORMATION SUR L'ENTITE">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-2">Gerant</dt>
                      <dd class="col-sm-3">{{ entity.gerant }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Nom commercial</dt>
                      <dd class="col-sm-3">{{ entity.nom_commercial }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Solde</dt>
                      <dd class="col-sm-3">{{ entity.solde }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Email</dt>
                      <dd class="col-sm-3">{{ entity.email }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Téléphone</dt>
                      <dd class="col-sm-3">{{ entity.telephone }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Type</dt>
                      <dd class="col-sm-3">{{ entity.type }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Description</dt>
                      <dd class="col-sm-10">{{ entity.description }}</dd>
                  </dl>
                </div>
            </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  name: 'tables',
   data(){
    return {
      entity:{
            nom_commercial: '',
            solde: '',
            email: '',
            telephone: '',
            type: '',
            gerant: '',
            email: '',
            description: ''
      }
    }
  },
  methods:{
    async displayEntity(){

        let response = await this.$store.dispatch('entity/show_entites',this.$route.params.id)
        this.entity.nom_commercial= response.nom_commercial,
        this.entity.solde= response.solde,
        this.entity.email= response.email,
        this.entity.telephone= response.telephone,
        this.entity.type= response.typeentite_libelle,
        this.entity.gerant= response.gerant,
        this.entity.email= response.email,
        this.entity.description=response.description
        }
    },
    mounted(){
        this.displayEntity()
    }
}
</script>
